// extracted by mini-css-extract-plugin
export default {"mainPage":"DashBoard_mainPage__Wt7CR","metricsWrap":"DashBoard_metricsWrap__qN3ND","contractBox":"DashBoard_contractBox__VKYKG"};